import config from '@/config'
import axios from 'axios'
import { DirectionsReponse } from '@/types/Maps'

class MapboxService {
  async getDirections (origin: string, destination: string): Promise<DirectionsReponse> {
    const response = await axios.get(config.mapbox.getDirectionsUrl(origin, destination))
    return response.data
  }
}

export default new MapboxService()
